/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { useServiceContext } from '../../root'

interface DateCellProps {
  val?: string | number | Date | null
  includeTime?: boolean
  className?: string
}

const DateCell: React.FC<DateCellProps> = ({ val, includeTime, className }) => {
  const context = useServiceContext()

  // Use the service context date formatter (matches original implementation)
  const formatDate = context.service.filter.date

  const combinedClassName = `whitespacepre d-inline-block${className ? ' ' + className : ''}`

  return <div className={combinedClassName}>{formatDate(val ?? null, includeTime)}</div>
}

export default DateCell
